import React from 'react';

const createReactClass = require('create-react-class');

const PhotoForTrailOrTrack = createReactClass({
  openLightbox(e) {
    e.preventDefault();
    this.props.openLightbox(this.props.index);
  },
  render() {
    const { photo } = this.props;
    if (!photo) {
      return null;
    }
    return (
      <div className="col-xs-12 col-sm-4 photo-tile">
        <div className="best-act">
          <div className="place rate">
            <div className="image xlate-none">
              <a className={photo.imageClass} onClick={this.openLightbox} rel="nofollow">
                <img src={photo.imageSrc} />
              </a>
            </div>
            <hgroup>
              <h3>
                <a className="link" href={photo.textLink}>
                  {photo.text}
                </a>
              </h3>
              <h4 className="middle-txt xlate-none">{photo.location}</h4>
              <h4 className="xlate-none">{photo.formattedCreatedAt}</h4>
            </hgroup>
            <span className="stars floatleft clear hidden" dangerouslySetInnerHTML={{ __html: photo.ratingInputs }} />
          </div>
        </div>
      </div>
    );
  }
});

export { PhotoForTrailOrTrack };
